import { useState, useContext } from "react";
import FormTitle from "../../components/helpers/FormTitle";
import { Box, Button, Typography, TextField, FormGroup } from "@mui/material";
import ActivitiesList from "../../components/administation/activites/ActivitiesList";
import LocalActivityIcon from "@mui/icons-material/LocalActivity";
import { BasicListContext } from "../../contexts/BasicListContext";
import BasicRadioGroup from "../../components/form/BasicRadioGoup";
import { _ACTIVE_RADIO_GROUP } from "../../utils/constants";
import AppRights from "../../services/AppRights";
import { _ROLES_BACK } from "../../utils/constants";

export const ActiviteAdmin = () => {
  const [showModal, setShowModal] = useState(false);
  const [editData, setEditData] = useState(null);
  const { extraQueryParams, setExtraQueryParams } =
    useContext(BasicListContext);

  return (
    <>
      <AppRights
        roles={[_ROLES_BACK._ROLE_ADMIN, _ROLES_BACK._ROLE_CONTROLE_GESTION]}
      />
      <FormTitle title="Activity management" />
      <Box
        width={"100%"}
        p={2}
        sx={{
          backgroundColor: "white",
        }}>
        <Box
          width={"100%"}
          display={"flex"}
          gap={1}
          alignItems={"baseline"}
          sx={{
            borderBottom: "1px solid #ccc",
          }}>
          <LocalActivityIcon />
          <Typography variant="h6" component="div">
            List of Activities
          </Typography>
        </Box>
        <Box sx={{ mt: 2, display: "flex", justifyContent: "space-between" }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}>
            <TextField
              id="outlined-basic"
              label="Find"
              variant="outlined"
              size="small"
              name="customFind"
              onBlur={(e) => {
                setExtraQueryParams({
                  ...extraQueryParams,
                  customFind: e.target.value ? e.target.value : null,
                });
              }}
            />
            <FormGroup
              sx={{
                alignItems: "center",
                display: "flex",
                flexDirection: "row",
                marginLeft: "10px",
              }}>
              <BasicRadioGroup
                setExtraQueryParams={setExtraQueryParams}
                extraQueryParams={extraQueryParams}
                choices={_ACTIVE_RADIO_GROUP}
                defaultValue={extraQueryParams?.active}
                onChange={(e) => {
                  setExtraQueryParams({
                    ...extraQueryParams,
                    active: e.target.value,
                  });
                }}
              />
            </FormGroup>
          </Box>
          <Box>
            <Button
              variant="contained"
              size="small"
              title={"Add an Activity"}
              startIcon={<LocalActivityIcon />}
              color="success"
              onClick={() => {
                // Modal create user
                setEditData(null);
                setShowModal(true);
              }}>
              {"Add an Activity"}
            </Button>
          </Box>
        </Box>
      </Box>
      <Box
        sx={{
          mt: 1,
          width: "100%",
        }}>
        <ActivitiesList
          editData={editData}
          setEditData={setEditData}
          showModal={showModal}
          setShowModal={setShowModal}
        />
      </Box>
    </>
  );
};

export default ActiviteAdmin;
